import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { ServicePlanFormData } from 'components/Assessments/ServicePlanAssessment/types/ServicePlanFormData'
import { ServicePlanAssessmentQuestionnaireItem } from 'components/Assessments/ServicePlanAssessment/types/questionnaire'
import { AuthorizationFormField } from './formField'

/**
 * Authorization subsection adapter for Service Plan Assessment
 * Handles authorization extraction and transformation
 */
export class AuthorizationAdapter extends BaseSubsectionAdapter<ServicePlanFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<ServicePlanFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const authorizationSources = getAnswerValuesFromItems(
      flatAnswersArray,
      ServicePlanAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    )

    const referenceStrings = authorizationSources
      .filter((source): source is { reference: string } => !!source?.reference)
      .map((source) => source.reference)

    return {
      [AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
        referenceStrings.length > 0 ? referenceStrings : undefined
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    if (
      !this.formDataFieldExists(
        AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
      )
    ) {
      return []
    }

    const authorizationSource = this.getFormDataField(
      AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    )
    return [
      {
        linkId:
          ServicePlanAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE,
        value: Array.isArray(authorizationSource)
          ? authorizationSource?.map((source) => (source ? { reference: source } : undefined))
          : authorizationSource
          ? { reference: authorizationSource }
          : undefined
      }
    ]
  }
}
